module.exports = __webpack_public_path__ + "img/invite_bg.050e6064.png";